export const coursesTags = {
  BC_JAVASCRIPT: "BC_JAVASCRIPT",
  BC_SALESFORCE: "BC_SALESFORCE",
  INTRO_JAVASCRIPT: "INTRO_JAVASCRIPT",
  INTRO_JAVASCRIPT_ATR: "INTRO_JAVASCRIPT_ATR",
};

export const urlToTag = {
  javascript: "BC_JAVASCRIPT",
  salesforce: "BC_SALESFORCE",
  intro: "INTRO_JAVASCRIPT",
};
